import React from 'react'
import "./Label.scss";

const Label = ({value, htmlFor, customClass}) => {
  return (
    <label className={`Label ${customClass}`} htmlFor={htmlFor}>{value}</label>
  )
}

export default Label;